module.exports = __webpack_public_path__ + "static/week_week6_spot6-7575739f5d71722a9cacf01a2f263cab.jpg";